export const dataTestid = 'applet-settings-live-response-streaming';
export const ipAddressFieldName = 'streamIpAddress';
export const portFieldName = 'streamPort';
